import React, { Component } from 'react';
import {Input,Modal,Row,Col, Form,Icon, Button, Select, DatePicker,message, InputNumber,Drawer,Spin } from 'antd';
import {pepoleWip,ArbitratorpepoleWip,mailFinder} from '../../stores/APIEndpoints';
import {booleanAsString, toUrlParams} from "../../stores/Util";
import DynamicForm from "../../components/DynamicForm";
import looseLeafStore from "../../stores/LooseLeafStore";
import {appStore} from '../../stores/AppStore';
import {inject, observer} from 'mobx-react';
import DashboardArbitratorStore from '../../stores/DashboardArbitratorStore';
const { Option } = Select;
import '../../../src/index.css';
import moment from 'moment';


@inject('dataStore')
@observer
class LooseLeafPeopleDrawer extends Component {
  
    constructor(props) {
        super(props);
        this.apiProxy = appStore.apiProxy;
        this.state = {
          updateWIP :'',
          updateArbitratorWIP :'',
          visible:false,
          loading: false,
          inputConfirmValue:'',
          errormsg:false,
          rollValue:'',
          children : []
        }
    }
    get store() {
        return DashboardArbitratorStore;
      
    }
    async componentDidMount() {
      

    }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        
          let data={};
          data.wip_authorEmails = values.wip_authorEmails;
          // data.authorNames = values.authorNames;
          data.wip_freelancerEmails = values.wip_freelancerEmails;
          // data.cmNames = values.cmNames;
          data.wip_cmEmails = values.wip_cmEmails;
          // data.editorNames = values.editorNames;
          this.store.savePeopleInfo(data);
      }
    });
  };
  getReseedAuthor=async(roll)=>{
    
  }
  getUpdateWip = async(roll)=>{
    const data = this.store.currentData;
    let replace={};
    this.props.form.validateFields((err, values) => {
      if (!err) {
          if(roll == 185)
          {
            replace.email = values.wip_authorEmails.toString().split(" ").join("").split(',').join(';');;
            replace.name = values.wip_authorNames;
          }
          else if(roll == 72)
          {
            replace.email = values.wip_cmEmails.toString().split(" ").join("").split(',').join(';');;
            replace.name = values.wip_cmNames;
          }
      }
    });
    const bodyParams = {
      "replace":replace,
      "project_id": data.projectId,
      "role_id":roll
    }
 
    let response = await this.apiProxy.asyncPost(pepoleWip, bodyParams);
    const option = await response.json();
    this.setState({updateWIP:option})
    if(option.message=="Updated Successfully")
    {
      this.setState({loading: false});
      message.success('Updated Successfully');
      this.store.fetchData();
    }
    else
    {
      this.setState({loading: false});
      message.error('Provide valid data');
      this.store.fetchData();
    }
   }

   updateWip = async(roll)=>{
     this.setState({visible: true});
     this.setState({rollValue: roll});
  }
  getArbitratorUpdateWip = async(roll)=>{
    const data = this.store.currentData;
    let replacefreelancer={};
    this.props.form.validateFields((err, values) => {
      if (!err) {
          if(roll == 117)
          {
            replacefreelancer.email = values.wip_freelancerEmails.toString().split(" ").join("").split(',').join(';');;
          }
          if(values.FreelancerChaseDate !="")
          {
            //  data.freelancerChaseDate = values.FreelancerChaseDate.year()+'-'+(values.FreelancerChaseDate.month()+1)+'-'+values.FreelancerChaseDate.date();
             data.freelancerChaseDate = moment(values.FreelancerChaseDate).format('YYYY-MM-DD');
            } 
      }
    });
    const bodyParams = {
      "freelancer":replacefreelancer.email,
      "chase_date": data.freelancerChaseDate,
      "project_id": data.projectId,
      "role_id":roll,
      "user_id":appStore.credentials.userId
    }
 
    let response = await this.apiProxy.asyncPost(ArbitratorpepoleWip, bodyParams);
    const options = await response.json();
    this.setState({updateArbitratorWIP:options})
    //if(options[0] != undefined || options[0] !=null)
      if(options.message != undefined && options.message == "Updated Successfully")
      {
        this.setState({loading: false});
        message.success('Updated Successfully');
        this.store.fetchData();
      }
    else if(options.errors=="Freelancer task already started. Unable to process given request")
    {
      this.setState({loading: false});
      message.error('Freelancer task already started. Unable to process given request');
      this.store.fetchData();
    }
    else if(options.errors=="Provide Valid Chase Date")
    {
      this.setState({loading: false});
      message.error('Provide Valid Chase Date');
      this.store.fetchData();
    }
    else
    {
      this.setState({loading: false});
      message.error('Provide valid data');
      this.store.fetchData();
    }
   }
   updateArbitratorWIP = async(roll)=>{
    this.setState({visible: true});
    this.setState({rollValue: roll});
 }

  handleOk = e => {
    //const currentData = this.store.currentData;
    this.setState({loading: true});
    if(this.state.inputConfirmValue == appStore.credentials.email)
    {
      this.setState({
        visible: false,
      });
      this.setState({errormsg:false})
      this.setState({
        inputConfirmValue: ''
      });
      if(this.state.rollValue == 185 || this.state.rollValue == 72)
      {
        this.getUpdateWip(this.state.rollValue);
      }
      else
      {
        this.getArbitratorUpdateWip(this.state.rollValue);
      }
      
    }
    else{
      this.setState({errormsg:true})
    }
  };
  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };
  handleSubmit = e => {
    e.preventDefault();
   
    this.props.form.validateFields((err, values) => {
      if (!err) {
          let data={};
          
           //data.authorNames =values.future_author;
         if(values.authorEmails != undefined)
         {
          data.authorEmails = values.authorEmails.toString().split(" ").join("").split(',').join(';'); 
         }
        // data.cmNames = values.future_cm;
         if(values.freelancerEmails != undefined)
         {
          data.freelancerEmails = values.freelancerEmails.toString().split(" ").join("").split(',').join(';');
         }
        //  data.editorNames = values.future_editor;
         if(values.cmEmails != undefined)
         {
          data.cmEmails = values.cmEmails.toString().split(" ").join("").split(',').join(';');
         }
          this.store.updateItem(data);
      }
    });
  };

handleChange=(value)=> {
  this.setState({children:[]});
 
}
validationText= async(value)=>{
  
  if(value.match(/@/g))
  {
    const params = {
      email:value
   };
    const url = mailFinder + '?' + toUrlParams(params);
    const response = await this.apiProxy.getAsync(url);
    const data = await response.json();
    const childrenData = [];
    if(data.length != 0)
    {
      for (let i = 0; i < data.length; i++) {
        childrenData.push(<Option key={data[i].name}>{data[i].name}</Option>);
      }
    }
    else
    {
      message.error('Please register new user.');
    }
     
     this.setState({children:childrenData});
     console.log(this.setState.children);
   
    
  }
  else
  {
  //	alert("false");
  }
}
clearChildred=()=>{
  this.setState({children:[]});
}
  renderPeopleForm = () => {
    const { getFieldDecorator } = this.props.form;
    const data = this.store.currentData;

    let peopleauthorEmails = '';
    if(data.authorEmails != null && data.authorEmails != undefined && data.authorEmails!='')
    {
      peopleauthorEmails = data.authorEmails.split(';');
    }
    else
    {
      peopleauthorEmails = data.authorEmails
    }
    let peoplefreelancerEmails = '';
    if(data.freelancerEmails != null && data.freelancerEmails != undefined && data.freelancerEmails!='')
    {
      peoplefreelancerEmails = data.freelancerEmails.split(';');
    }
    else
    {
      peoplefreelancerEmails = data.freelancerEmails;
    }
    let peoplecmEmails = '';
    if(data.cmEmails != null && data.cmEmails != undefined && data.cmEmails!='')
    {
      peoplecmEmails = data.cmEmails.split(';');
    }
    else
    {
      peoplecmEmails = data.cmEmails;
    }
    
    const fieldDefs = [
      {
        key: "authorNames",
        label: "Arbitrator Names :",
        type: "text",
        defaultValue: data.authorNames,
        disabled: false
    },{
        key: "authorEmails",
        label: "Arbitrator Emails :",
        type: "text",
        defaultValue: data.authorEmails,
        disabled: false
    }, 
    {
      key: "freelancerNames",
      label: "Freelancer Names :",
      type: "text",
      defaultValue: data.freelancerNames,
      disabled: false
  }, {
        key: "freelancerEmails",
        label: "Freelancer Emails :",
        type: "text",
        defaultValue: data.freelancerEmails,
        disabled: false
    },
    {
      key: "cmNames",
      label: "CM Names :",
      type: "text",
      defaultValue: data.cmNames,
      disabled: false
  },  {
        key: "cmEmails",
        label: "CM Emails :",
        type: "text",
        defaultValue: data.cmEmails,
        disabled: false
    }];
    return (
            <div>
               <Spin style={{position:"absolute",top:"40px",textAlign:"center",left:"20%"}} spinning={this.state.loading}>
               </Spin>
            <Form name="normal_login"  className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
            <h3 style={{"margin-top":"0px"}}>People - Next cycle</h3>
            <Form.Item label="Arbitrator Names"  name="ArbitratorName" >
          {getFieldDecorator('authorNames', {
              initialValue:data.authorNames,
              rules: []
              })(
              <Input disabled style={{ width: '100%' }} />
              )}
          </Form.Item>
           
              <Form.Item label="Arbitrator Emails"  name="ArbitratorEmail" >
              {getFieldDecorator('authorEmails', {
                  initialValue:peopleauthorEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>
              
         <Form.Item label="Freelancer Names"  name="FreelancerName" >
         {getFieldDecorator('freelancerNames', {
             initialValue:data.freelancerNames,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>

              <Form.Item label="Freelancer Emails"  name="FreelancerEmail" >
              {getFieldDecorator('freelancerEmails', {
                  initialValue:peoplefreelancerEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>


         <Form.Item label="CM Names"  name="CMName" >
         {getFieldDecorator('cmNames', {
             initialValue:data.cmNames,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
            <Form.Item label="CM Emails"  name="CMEmail" >
              {getFieldDecorator('cmEmails', {
                  initialValue:peoplecmEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>
       </Form>
       <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={this.handleSubmit} className="login-form-button">Update </Button>

              {/* <DynamicForm
                  items={fieldDefs}
                  onSubmit={data => this.store.updateItem(data)}
                  submitButtonText={'Save and Next'}
                  submitButtonProps={{loading: this.store.formLoading}}
              /> */}
            </div>
     
    );
};
renderUpdateForm=()=>{
  const { getFieldDecorator } = this.props.form;
  const data = this.store.currentData;
  
  let wipauthorEmails
  if(data.wip_authorEmails != null && data.wip_authorEmails != undefined && data.wip_authorEmails!='')
  {
    wipauthorEmails = data.wip_authorEmails.split(';');
  }
  else
  {
    wipauthorEmails = data.wip_authorEmails
  }
  let wipfreelancerEmails = '';
  if(data.wip_freelancerEmails != null && data.wip_freelancerEmails != undefined && data.wip_freelancerEmails!='')
  {
    wipfreelancerEmails = data.wip_freelancerEmails.split(';');
  }
  else
  {
    wipfreelancerEmails = data.wip_freelancerEmails
  }
  let wipcmEmails = '';
  if(data.wip_cmEmails != null && data.wip_cmEmails != undefined && data.wip_cmEmails!='')
  {
    wipcmEmails = data.wip_cmEmails.split(';');
  }
  else
  {
    wipcmEmails = data.wip_cmEmails
  }
  return(
    <div>
          <Spin style={{position:"absolute",top:"40px",textAlign:"center",left:"20%"}} spinning={this.state.loading}>
          </Spin>
          <Form name="normal_login"  className="login-form" initialValues={{ remember: true }} onSubmit={this.handleSubmit}>
        <h3>People - WIP</h3>
        <Row style = {{"background":"#f5f5f5","padding":"10px","margin-bottom":"10px"}}>
        <Col span={24}>
        <Form.Item label="Arbitrator Names"  name="ArbitratorName" >
          {getFieldDecorator('wip_authorNames', {
              initialValue:data.wip_authorNames,
              rules: []
              })(
              <Input disabled style={{ width: '100%' }} />
              )}
          </Form.Item>
              <Form.Item label="Arbitrator Emails"  name="ArbitratorEmail" >
              {getFieldDecorator('wip_authorEmails', {
                  initialValue:wipauthorEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>

           
              <Form.Item>
                <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={()=>this.updateWip(185)} className="login-form-button">Update WIP</Button>
              </Form.Item>
            </Col>
          </Row>

        <Row style = {{"background":"#f5f5f5","padding":"10px","margin-bottom":"10px"}}>
        <Col span={24}>

        <Form.Item label="Freelancer Chase Date"  name="FreelancerChaseDate" >
            {getFieldDecorator('FreelancerChaseDate', {
                  initialValue:(data.freelancerChaseDate != null ? moment(data.freelancerChaseDate, 'YYYY-MM-DD'):'')
                })(
              <DatePicker style={{ width: '100%' }}  onChange={this.onChangefreelancerChaseDate}  format={'YYYY-MM-DD'} />
            )}
            </Form.Item>

         <Form.Item label="Freelancer Names"  name="FreelancerName" >
         {getFieldDecorator('wip_freelancerNames', {
             initialValue:data.wip_freelancerNames,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
        
              <Form.Item label="Freelancer Emails"  name="FreelancerEmail" >
              {getFieldDecorator('wip_freelancerEmails', {
                  initialValue:wipfreelancerEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>
           
              <Form.Item>
                <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={()=>this.updateArbitratorWIP(117)}className="login-form-button">Update WIP</Button>
              </Form.Item>
            </Col>
          </Row>

        
         

        <Row style = {{"background":"#f5f5f5","padding":"10px","margin-bottom":"10px"}}>
        <Col span={24}>
         <Form.Item label="CM Names"  name="CMName" >
         {getFieldDecorator('wip_cmNames', {
             initialValue:data.wip_cmNames,
             rules: []
            })(
             <Input disabled style={{ width: '100%' }} />
            )}
         </Form.Item>
            <Form.Item label="CM Emails"  name="CmEmail" >
              {getFieldDecorator('wip_cmEmails', {
                  initialValue:wipcmEmails,
                  rules: []
                  })(
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onSearch={this.validationText}
                      onChange={this.handleChange}
                      
                    >
                      {this.state.children}
                    </Select>,
                    )}
              </Form.Item>

            <Form.Item>
             <Button style={{"float":"right","margin-top":"10px"}} type="primary" onClick={()=>this.updateWip(72)} className="login-form-button">Update WIP</Button>
            </Form.Item>
          </Col>
        </Row>
       </Form>
    </div>
  )
}
updateConfirmValue = (evt)=> {
  this.setState({
    inputConfirmValue: evt.target.value
  });
}
  render() {
     const data = this.store.currentData;
    // const title = data.id === undefined ? "New Title" : data.abbreviation + " - " + data.publication;
      if(data.projectId>0)
      {
        return (
          <div>
            {this.renderUpdateForm()}
            {this.renderPeopleForm()}
            <Spin spinning={this.state.loading}>
            </Spin>
            <Modal
             // title={title}
              visible={this.state.visible}
              onOk={this.handleOk}
              onCancel={this.handleCancel}
            >
              <div className="deleteText">Confirm you want to update this email by typing your email: <b>{appStore.credentials.email}</b></div>
              <div className="deletePara"><Input value={this.state.inputConfirmValue} onChange={this.updateConfirmValue} placeholder={appStore.credentials.email} /></div>
              {this.state.errormsg ? <div className="errormsg"><sup>**</sup> Email are not matching</div>:''}
            </Modal>
          </div>
        );
      }
      else{
        return (
          <div>
            {this.renderPeopleForm()}
          </div>
        );
      }
     
   
  }
}

export default Form.create({ name: 'normal_login' })(LooseLeafPeopleDrawer);

// export default WrappedNormalLoginForm;

